import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Box, Flex } from '../../../../units/Box/Box';
import Button from '../../../../units/Button/Button';

const HintsBox = styled(Box)`
  font-family: ${props => props.theme.fonts.regular};
`;

const PasswordForm = ({ fields, applyAction }) => {
  const close = () => {
    applyAction({
      actionId: '_close'
    });
  };

  return (
    <Box>
      <HintsBox dangerouslySetInnerHTML={{ __html: fields.hints.value }} />

      <Flex mt="25px" justify="flex-end">
        <Button size="medium" font="caption" onClick={close} bold>
          Закрыть
        </Button>
      </Flex>
    </Box>
  );
};

PasswordForm.propTypes = {
  applyAction: PropTypes.func.isRequired,
  fields: PropTypes.object.isRequired
};

export default PasswordForm;



// WEBPACK FOOTER //
// ./src/components/containers/Forms/FormsComponents/PasswordHintsForm/PasswordHintsForm.js